import React from "react";
import { Typography, Box, Skeleton } from "@mui/material";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
  Legend,
} from "recharts";
import { ResponsibleData } from "../../../services/api/dashboard/dashboardApi";

interface ResponsibleChartProps {
  data: ResponsibleData[] | undefined;
  loading: boolean;
}

export default function ResponsibleChart({
  data,
  loading,
}: ResponsibleChartProps) {
  // Pegar top 10 responsáveis
  const top10Data = React.useMemo(() => {
    if (!data) return [];
    return [...data]
      .sort((a, b) => b.count - a.count)
      .slice(0, 10);
  }, [data]);

  // Custom tooltip
  const CustomTooltip = ({ active, payload }: any) => {
    if (active && payload && payload.length) {
      const data = payload[0].payload;
      return (
        <Box
          sx={{
            backgroundColor: "white",
            border: "1px solid #ccc",
            borderRadius: 1,
            p: 1.5,
            boxShadow: 2,
          }}
        >
          <Typography variant="body2" fontWeight="bold">
            {data.userName}
          </Typography>
          <Typography variant="body2" color="primary">
            Atividades: {data.count}
          </Typography>
          <Typography variant="body2" color="text.secondary">
            Tempo médio: {data.avgExecutionTime?.toFixed(1) || "N/A"}h
          </Typography>
          <Typography variant="body2" color="text.secondary">
            Taxa conclusão: {data.completionRate?.toFixed(1) || "N/A"}%
          </Typography>
        </Box>
      );
    }
    return null;
  };

  if (loading) {
    return (
      <Box>
        <Skeleton variant="text" width="40%" height={32} />
        <Skeleton variant="rectangular" height={300} sx={{ mt: 2 }} />
      </Box>
    );
  }

  return (
    <Box>
      <Typography 
        variant="h6" 
        component="h3" 
        sx={{ 
          fontSize: "1rem", 
          fontWeight: 600, 
          mb: 2,
          color: "text.primary"
        }}
      >
        Atividades por Responsável
      </Typography>
      
      <Box sx={{ width: "100%", height: 400 }}>
        <ResponsiveContainer>
          <BarChart
            data={top10Data}
            layout="vertical"
            margin={{ top: 5, right: 30, left: 100, bottom: 5 }}
          >
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis type="number" style={{ fontSize: 12 }} />
            <YAxis
              dataKey="userName"
              type="category"
              style={{ fontSize: 12 }}
              width={95}
            />
            <Tooltip content={<CustomTooltip />} />
            <Legend />
            <Bar
              dataKey="count"
              fill="#1976d2"
              name="Quantidade"
              radius={[0, 4, 4, 0]}
            />
          </BarChart>
        </ResponsiveContainer>
      </Box>
    </Box>
  );
}

